import React from 'react';
import viewContext from '../../contexts/viewContext';

const View = ({ ...props }) => {
  return (
    <viewContext.Consumer>
      {value => React.cloneElement(value, { ...props })}
    </viewContext.Consumer>
  )
}
export default View